/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { Button, ButtonProps, theme } from "@nordcloud/gnui";

type Props = ButtonProps & { inline?: boolean };

export function EditButton({ onClick, inline = false }: Props) {
  return (
    <StyledButton
      inline={inline}
      severity="low"
      size="sm"
      icon="edit"
      aria-pressed="false"
      data-testid="btn-edit"
      onClick={onClick}
    />
  );
}

const StyledButton = styled(Button)<{
  inline: boolean;
}>`
  margin: 0;
  border-radius: ${theme.radius.xxl};
  padding: ${theme.spacing.spacing01};
  display: ${(inline) => (inline ? "inline-block" : "inherit")};
`;
